import { useTextHighlighter } from '@/pages/experiences/hooks/useTextHighlighter';
import { RefObject } from 'react';

export interface HighlightOptions {
  highlightsIdentifier: string;
  handleHighlightOnChange: (data: {
    highlighter: { text_highlights: any[]; image_highlights: any[] };
  }) => void;
}

interface TextHighlighterInitializerProps {
  htmlRef: RefObject<HTMLElement | null>;
  highlightOptions: HighlightOptions;
}

/**
 * Initializer component that conditionally initializes the text highlighter hook.
 * This component renders nothing - it only manages the highlighter hook lifecycle.
 *
 * By using this initializer, we avoid running the expensive useTextHighlighter hook
 *
 * when highlightOptions are not provided (e.g., on teacher side).
 */
export const TextHighlighterInitializer = ({
  htmlRef,
  highlightOptions,
}: TextHighlighterInitializerProps) => {
  useTextHighlighter(htmlRef, highlightOptions);
  return null;
};
